<section class="mt-3 mb-5">
  <div class="container">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link to="/">Home</router-link>
      </li>
      <li class="breadcrumb-item">
        <router-link to="/blog">Editorial</router-link>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        {{blog.title }}
      </li>
    </ol>
    <h1 class="my-3 text-center text-muted">{{blog.title}}</h1>
    <div class="text-center">
      <img
        class="card-img-top w-50"
        :src="blog.thumbnail_url"
        alt="Card image cap"
      />
    </div>
    <div class="card-body my-3 container blog">
      <div class="mt-3" v-html="blog.description"></div>
    </div>
  </div>
</section>
